define('modules/order',["jquery", "app", "modules/pathfinder", "modules/rackUtils"], function($, App,  pathfinder, RackUtils) {

    function processPaths(pathMatrix) {
        var length = pathMatrix.length;
        var memory = new Array(1 << length);
        for(var i=0; i<memory.length; i++) {
            memory[i] = new Array(length).fill(Infinity);
        }

        memory[1][0] = 0;

        for (var mask = 1; mask < 1 << length; mask += 2) {
            for (var i = 1; i < length; i++) {
                if ((mask & 1 << i) != 0) {
                    for (var j = 0; j < length; j++) {
                        if ((mask & 1 << j) != 0) {
                            memory[mask][i] = Math.min(memory[mask][i], memory[mask ^ (1 << i)][j] + pathMatrix[j][i].length);
                        }
                    }
                }
            }
        }

        var res = Infinity;
        for (var i = 1; i < length; i++) {
            res = Math.min(res, memory[(1 << length) - 1][i] + pathMatrix[i][0].length);
        }

        // Path
        var cur = (1 << length) - 1;
        var path = new Array(length);
        var last = 0;
        for (var i = length - 1; i >= 1; i--) {
            var bj = -1;
            for (var j = 1; j < length; j++) {
                if ((cur & 1 << j) != 0
                        && (bj == -1 || memory[cur][bj] + pathMatrix[bj][last].length > memory[cur][j] + pathMatrix[j][last].length)) {
                    bj = j;
                }
            }
            path[i] = bj;
            cur ^= 1 << bj;
            last = bj;
        }

        path[0] = 0;

        var finalPaths = [];
        for(var i=0;i < length; i++) {
            var next = (i == length-1) ? 0 : i+1;
            var thispath = pathMatrix[path[i]][path[next]];
            finalPaths.push(thispath.path.slice(0));
        }
        App.page.render('map', {mode : 'order', paths: finalPaths});
    }

    return {
        getPathForOrder: function(order, startPoint, onError) {
            var currentFloor = App.global('map_floor');
            var canvas = App.global('map_floor_' + currentFloor).canvas;

            App.database.instance.products
                .where("id")
                .anyOf(order.item_details.map(function(p){return '' + p.id;}))
                .toArray(function(products) {
                    if(!products.length) {
                        onError('We don\'t have information about any of the products from the order');
                        return;
                    }

                    var rackIds = [];
                    var racks = {};
                    products.forEach(function(product) {
                        if(product.rack_number) {
                            var id = App.utils.getId(product.rack_number);
                            var rackInfo = RackUtils.check(id, currentFloor);
                            if(rackInfo.existsOnCurrentFloor) {
                                racks[id] = rackInfo.value;
                                rackIds.push(id);
                            }
                        }
                    });

                    if(!rackIds.length) {
                        onError('None of the products in the order are locatable as of now');
                        return;
                    }

                    rackIds.unshift('start');
                    racks.start = [startPoint];

                    //Defined distance matrix for the points
                    var length = rackIds.length;
                    var pathMatrix = new Array(length);
                    for(i=0; i<length; i++) {
                        pathMatrix[i] = new Array(length);

                        //Distance to same point
                        var r = rackIds[i];
                        var point = racks[r][0];
                        pathMatrix[i][i] = {
                            start : rackIds[i],
                            end : rackIds[i],
                            path : [point, point],
                            length : 0
                        };
                    }

                    for(i=0; i<length-1; i++) {
                        for(j=i+1;j<length;j++) {
                            var points =  [rackIds[i], rackIds[j]].map(function(r) {
                                return racks[r][0];
                            });
                            var result = pathfinder.getPath(canvas, points[0], points[1]);
                            pathMatrix[i][j] = {
                                start : rackIds[i],
                                end : rackIds[j],
                                path : result.path,
                                length : result.length
                            };
                            pathMatrix[j][i] = {
                                start : rackIds[j],
                                end : rackIds[i],
                                path : result.path.slice(0).reverse(),
                                length : result.length
                            };
                        }
                    }
                    processPaths(pathMatrix);
                });
        }
    };
});
